<ng-container [formGroup]="form">
  <p class="mb-6">Veuillez sélectionner la période concernée</p>
  <div class="flex flex-row gap-4">
    <base-form-input
      class="w-1/2"
      label="Date de début"
      controlName="periodStart"
      type="date"
      [minDate]="minDate"
    ></base-form-input>
    <base-form-input
      class="w-1/2"
      label="Date de fin"
      controlName="periodEnd"
      type="date"
      [minDate]="form.get('periodStart')?.value || minDate"
    ></base-form-input>
  </div>

  <p class="mb-2">Veuillez sélectionner les jours travaillés de la semaine</p>
  <mat-button-toggle-group class="mb-6" multiple formControlName="workedDays" aria-label="Jours travaillés">
    <mat-button-toggle *ngFor="let day of weekDayOptions" [value]="day.value">{{ day.label }}</mat-button-toggle>
  </mat-button-toggle-group>

  <p class="mb-6">Veuillez préciser le nombre moyen d'heures travaillées quotidiennement</p>
  <base-form-input
    label="Heures par jour"
    controlName="dailyHours"
    type="text"
    invalidPatternMessage="Format attendu : 7h45"
    customErrorMessage="Entre 0h15 et 24h00, par quart d'heure"
  ></base-form-input>
</ng-container>
